import React from "react";

import GovernanceExceptionQueue from "@/components/governance/GovernanceExceptionQueue";

const PMExceptionQueue: React.FC = () => (
  <GovernanceExceptionQueue
    title="Applications That Need PM Attention"
    roleScope="pm"
    subtitle="Review only the applications that need escalation, reassignment, or PM intervention."
    emptyCopy="No applications currently need PM attention. When applications require escalation, reassignment, or intervention they will appear here."
    submissionHrefBuilder={(tenantSlug, submissionId) =>
      `/${tenantSlug}/pm/dashboard?submission=${submissionId}&view=exceptions`
    }
    openSubmissionLabel="Open workbench"
    taskOrientedEmptyState
    alignStart
  />
);

export default PMExceptionQueue;
